// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "q6") return "static/css/vanilla-extract/q6.ea690d507a.css";
if (chunkId === 5) return "static/css/async/vanilla-extract/5.0e8fb7d761.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}